import { ArgsType, Field, Int } from '@nestjs/graphql'
import { BaseGetArgs } from '../base/baseGet.args'

@ArgsType()
export class BookGetArgs extends BaseGetArgs<BookGetArgs> {
  @Field({ nullable: true })
  needle?: string

  @Field({ nullable: true })
  isDraft?: boolean

  @Field(t => Int, { nullable: true })
  penNameId?: number

  @Field({ nullable: true })
  seriesName?: string

  @Field(t => Int, { nullable: true })
  beforeSeriesNumber?: number

  @Field({ nullable: true })
  allowImportedDrafts?: boolean

  @Field({ nullable: true })
  hasReviews?: boolean

  @Field({ nullable: true })
  missingPreview?: boolean
}
